/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetPlayerActivityStatement200ResponseHeader9Inner
 */
export interface GetPlayerActivityStatement200ResponseHeader9Inner {
    /**
     * 
     * @type {string}
     * @memberof GetPlayerActivityStatement200ResponseHeader9Inner
     */
    monthHeading?: string;
}


/**
 * Check if a given object implements the GetPlayerActivityStatement200ResponseHeader9Inner interface.
 */
export function instanceOfGetPlayerActivityStatement200ResponseHeader9Inner(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GetPlayerActivityStatement200ResponseHeader9InnerFromJSON(json: any): GetPlayerActivityStatement200ResponseHeader9Inner {
    return GetPlayerActivityStatement200ResponseHeader9InnerFromJSONTyped(json, false);
}

export function GetPlayerActivityStatement200ResponseHeader9InnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlayerActivityStatement200ResponseHeader9Inner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'monthHeading': !exists(json, 'monthHeading') ? undefined : json['monthHeading'],
    };
}

export function GetPlayerActivityStatement200ResponseHeader9InnerToJSON(value?: GetPlayerActivityStatement200ResponseHeader9Inner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'monthHeading': value.monthHeading,
    };
}

